import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography, Paper } from '@mui/material';
import { Error as ErrorIcon, Home as HomeIcon } from '@mui/icons-material';

export const NotFoundPage: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          py: 4
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 5,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: 600
          }}
        >
          <ErrorIcon color="error" sx={{ fontSize: 72, mb: 2 }} />
          
          <Typography variant="h1" color="error" gutterBottom>
            404
          </Typography>
          
          <Typography variant="h4" gutterBottom>
            Страница не найдена
          </Typography>
          
          <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
            Извините, но страница, которую вы ищете, не существует или была перемещена.
          </Typography>
          
          <Button
            variant="contained"
            component={RouterLink}
            to="/"
            startIcon={<HomeIcon />}
            size="large"
          >
            Вернуться на главную
          </Button>
        </Paper>
      </Box>
    </Container>
  );
}; 